import {Component, Input, Output, AfterViewInit, OnInit, ViewChild, EventEmitter, ElementRef} from '@angular/core';
import SignaturePad from 'signature_pad';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';

@Component({
  selector: 'app-modal-signature',
  templateUrl: './modal-signature.component.html',
  styleUrls: ['./modal-signature.component.css'],
  standalone: false
})
export class ModalSignatureComponent implements OnInit, AfterViewInit {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;
  @Output() signatureEmit = new EventEmitter<string>();
  @Output() signatureDeleteEmit = new EventEmitter<boolean>();

  @ViewChild('sPad', {static: true}) signaturePadElement!: ElementRef<HTMLCanvasElement>;
  signaturePad: any;

  constructor(private notification: BsToastService, private confirmDialogService: ConfirmDialogService) {
  }

  ngOnInit() {
    // Defer any canvas operations until the view (and modal content) is initialized
  }

  signaturetext() {
    try {
      this.vm.today = new Date();
      const canvas: HTMLCanvasElement | null =
        (this.signaturePadElement?.nativeElement as HTMLCanvasElement) ||
        (document.getElementById('signature-pad') as HTMLCanvasElement | null);
      if (!canvas) {
        return;
      }
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return;
      }
      // ctx.fillText('', 20, 270);
      ctx.font = '12px sans-serif';
      ctx.fillStyle = 'dodgerblue';
      if (this.vm.addTextSignature) {
        ctx.fillText(this.vm.addTextSignature, 20, 260);
        ctx.fillText(String(this.vm.today), 20, 290);
      } else {
        ctx.fillText(String(this.vm.today), 20, 290);
      }
    } catch {
      // no-op: safely ignore drawing errors when canvas/modal not present yet
    }
  }

  addSignatureName(signatureName) {
    this.vm.signatureName = signatureName;
    const canvas: HTMLCanvasElement | null =
      (this.signaturePadElement?.nativeElement as HTMLCanvasElement) ||
      (document.getElementById('signature-pad') as HTMLCanvasElement | null);
    const ctx = canvas?.getContext('2d');
    if (ctx) {
      ctx.font = '12px sans-serif';
      ctx.fillStyle = 'dodgerblue';
    }
    // ctx.fillStyle = 'lightgray';
    if (!this.vm.signatureName){
      this.notification.showWarningToast($localize`:Enter Signer Name. @@Enter Signer Name:Enter Signer Name.`);
    } else if (this.vm.signatureName && ctx) {
      ctx.fillText($localize`:Signed By @@Signed By:Signed By` + ' - ' + this.vm.signatureName, 20, 275);
    }
  }

  ngAfterViewInit() {
    try {
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
      this.signaturePad.penColor = 'rgb(66, 133, 244)';
      // Draw helper text for new signatures on initial load
      this.signaturetext();
    } catch {
      // ignore initialization issues if modal not yet fully attached
    }

    // Each time the modal opens: load existing signature OR reset to new-signature mode
    const modalEl = document.getElementById('signatureModal');
    if (modalEl) {
      modalEl.addEventListener('show.bs.modal', () => {
        const existing = this.vm?.item?.header?.signature;
        if (existing) {
          // Existing signature mode: show the saved signature, no helper text
          this.signaturePad.clear();
          this.signaturePad.fromDataURL(existing);
        } else {
          // New signature mode: clear and draw helper text
          this.signaturePad.clear();
          this.signaturetext();
        }
      });
    }
  }

  clearSignature() {
    try {
      this.signaturePad.clear();
    } catch {
    }
    this.vm.signatureName = '';
    this.vm.today = new Date();
    this.signaturetext();
  }

  signature() {
    if (this.signaturePad.isEmpty()) {
      this.notification.showWarningToast($localize`:Must provide a signature. @@Must provideasignature:Must provide a signature.`);
    } else if (!this.vm.signatureName) {
      this.notification.showWarningToast($localize`:Enter Signer Name. @@Enter Signer Name:Enter Signer Name.`);
    } else {
      const dataURL = this.signaturePad.toDataURL();
      this.signatureEmit.emit(dataURL);
      this.clearSignature();
    }
  }

  deleteItem() {
    const brClass = this;
    const retMsg = '';
    const messages: string[] = ['Are you sure you want to remove signature', retMsg];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.deleteSignature();
      },
      () => {
        brClass.notification.showSuccessToast('Delete Canceled');
      }
    );
  }

  deleteSignature() {
    this.signatureDeleteEmit.emit(true);
  }
}
